import { DISMISSED_LIVE_TRIPS_KEY } from "../action/liveTrips";

const loadDismissed = () => {
  try {
    const stored = JSON.parse(
      localStorage.getItem(DISMISSED_LIVE_TRIPS_KEY) || "[]"
    );
    return Array.isArray(stored) ? stored : [];
  } catch (e) {
    return [];
  }
};

const initialState = {
  trips: [],
  dismissed: loadDismissed(),
  loading: false,
};

export const liveTripsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GETTING_LIVE_TRIPS":
      return { ...state, loading: true };

    case "GOT_LIVE_TRIPS":
      return {
        ...state,
        loading: false,
        trips: Array.isArray(action.payload) ? action.payload : [],
      };

    case "CANNOT_GET_LIVE_TRIPS":
      return { ...state, loading: false };

    case "DISMISS_LIVE_TRIP":
      return {
        ...state,
        dismissed: state.dismissed.includes(action.payload)
          ? state.dismissed
          : [...state.dismissed, action.payload],
      };

    default:
      return state;
  }
};
